// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import Element from "element-ui";
import qs from "qs";
import "element-ui/lib/theme-chalk/index.css";
import VueTouch from "vue-touch";
import Vant, { Lazyload, Toast } from "vant";
import "vant/lib/index.css";
import { queryUserInfoBasic } from "./assets/js/common.js";
//import BaiduMap from "vue-baidu-map";
import VueCanvasPoster from "vue-canvas-poster";
import VueClipBoard from "vue-clipboard2";
import md5 from "js-md5";
//import Vconsole from "vconsole";
//let vConsole = new Vconsole();
//Vue.use(vConsole);
Vue.use(VueClipBoard);
Vue.prototype.$md5 = md5;
Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(VueTouch, { name: "v-touch" });
Vue.use(Element);
Vue.prototype.qs = qs;
Vue.prototype.$axios = axios;
axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded";
axios.defaults.baseURL = "//www.jywmsj.com";
//http://221.228.70.84:82
//http://221.228.70.219:81
Vue.config.productionTip = false;
/* Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key
  ak: "xwYMjzVQrbLBGNkYbYN9ifSk3s7io1TE"
}); */
Vue.use(VueCanvasPoster);

//sessionStorage.setItem("uid", ""); //
//sessionStorage.setItem("mobile", ""); //
//console.log(location.href);

Vue.prototype.timeTrans = function (time) {
  let date = new Date(parseInt(time) * 1000);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;
  //console.log( y + '-' + m + '-' + d + ' ' + '　' + h + ':' + minute + ':' + second);
  time = y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
  return time;
};
(Vue.prototype.timeTransevent = function (time) {
  let date = new Date(parseInt(time) * 1000);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;
  //console.log( y + '-' + m + '-' + d + ' ' + '　' + h + ':' + minute + ':' + second);
  time = y + "年" + m + "月" + d + "日" + h + ":" + minute;
  return time;
}),
  (Vue.prototype.timeTransdate = function (time) {
    let date = new Date(parseInt(time) * 1000);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    let d = date.getDate();
    d = d < 10 ? "0" + d : d;
    let h = date.getHours();
    h = h < 10 ? "0" + h : h;
    let minute = date.getMinutes();
    let second = date.getSeconds();
    minute = minute < 10 ? "0" + minute : minute;
    second = second < 10 ? "0" + second : second;
    //console.log( y + '-' + m + '-' + d + ' ' + '　' + h + ':' + minute + ':' + second);
    time = y + "年" + m + "月" + d + "日";
    return time;
  }),
  //路由守卫
  router.beforeEach((to, from, next) => {
    if (to.meta.title) {
      document.title = to.meta.title;
    }
    //next()
    if (to.meta.requireAuth) {
      // 判断该路由是否需要登录权限
      if (sessionStorage.getItem("wmtoken") && sessionStorage.getItem("uid")) {
        // 获取当前的token和uid是否存在
        next();
      } else {
        console.log("路由调用了app_login");
        var appId = "2312";
        zjyapi.init({
          appId: appId,
          error: function (code, ret) {
            //失败回调,默认
            Toast("初始化失败");
          },
          success: function success(ret) {
            queryUserInfoBasic().then(res => {
              console.log("applogin结果：");
              console.log(res);
              if (res.code != 0 && to.meta.needin) {
                Toast(res.msg);
                next();
              } else if (res.code != 0) {
                Toast(res.msg);
              } else {
                next();
              }
            });
          }
        });
        //next(); //new
      }
    } else {
      next();
    }
  });

//http拦截
axios.interceptors.response.use(
  response => {
    //console.log(response.data.code);
    //311且不为首页时，跳转到注册页
    if (response.data.code == 311 && router.history.current.name != "home") {
      sessionStorage.removeItem("wmtoken");
      Toast(response.data.msg);
    }
    //300,310判断是否有uid，没有则获取存储用户uid，连login_app接口存储token，刷新页面
    if (response.data.code == 300 || response.data.code == 301) {
      sessionStorage.removeItem("wmtoken");
      if (!sessionStorage.getItem("uid")) {
        var appId = "2312";
        zjyapi.init({
          appId: appId,
          error: function (code, ret) {
            //失败回调,默认
            Toast("初始化失败");
          },
          success: function success(ret) {
            queryUserInfoBasic();
          }
        });
      } else {
        axios({
          method: "post",
          url: "/api/member/login_app",
          data: qs.stringify({
            zjyuid: sessionStorage.getItem("uid"),
            mobile: sessionStorage.getItem("mobile")
          })
        }).then(res => {
          console.log("login_app");
          console.log(res.data);
          if (res.data.code == 0) {
            sessionStorage.setItem("wmtoken", res.data.data.token);
            sessionStorage.setItem("wmmember", res.data.data);
            Toast("请再试一次");
            // location.reload();
          } else {
            //Toast(res.data.msg);
          }
        });
      }
    }
    return response;
  },
  error => {
    if (error.response) {
      console.log("error");
      console.log(error.response);
    }
    return Promise.reject(error.response.data);
  }
);
axios.interceptors.request.use(
  config => {
    if (sessionStorage.getItem("wmtoken") != null) {
      config.headers["token"] = sessionStorage.getItem("wmtoken");
    }

    return config;
  },
  err => Promise.reject(err)
);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js